import { useState } from "react";
import { motion } from "framer-motion";

export function Example() {
    const [color, setColor] = useState(
        `hsl(${Math.floor(Math.random() * 360)},80%,50%)`
    );

    function changeColor() {
        setColor(`hsl(${Math.floor(Math.random() * 360)},80%,50%)`);
    }

    return (
        <motion.div
            style={{
                width: 150,
                height: 150,
                borderRadius: 30,
                backgroundColor: "#fff",
                boxShadow: "0px 5px 8px #207",
                cursor: "pointer"
            }}
            initial={false}
            animate={{ backgroundColor: color }}
            onTap={changeColor}
            transition={{ duration: 0.5 }}
        />
    );
}
